/**
 * Üst menü mega panel içerikleri (metinler `src/i18n/locales/*.json` içinde).
 * @typedef {{ linkKey: string, to: string }} HeaderMegaLink
 * @typedef {{
 *   id: string,
 *   labelKey: string,
 *   introTitleKey: string,
 *   introTextKey: string,
 *   columns: HeaderMegaLink[][],
 *   activePathMatchers: string[],
 * }} HeaderMegaMenu
 */

/**
 * Mevcut path, verilen öneklerden biriyle eşleşiyor mu (tam veya alt rota).
 * @param {string} pathname
 * @param {string[] | undefined} matchers
 */
export function headerPathMatches(pathname, matchers) {
    if (!matchers?.length) return false;
    return matchers.some(
        (base) => pathname === base || pathname.startsWith(`${base}/`),
    );
}

/** @type {HeaderMegaMenu[]} */
export const HEADER_MEGA_MENUS = [
    {
        id: 'kulubumuz',
        labelKey: 'header.mega.kulubumuz.label',
        activePathMatchers: [
            '/our-club',
            '/management-board',
            '/imprint',
            '/history',
            '/financial-statements',
            '/past-presidents',
            '/60-year-honorary-members',
            '/senior-five-presidents',
        ],
        introTitleKey: 'header.mega.kulubumuz.introTitle',
        introTextKey: 'header.mega.kulubumuz.introText',
        columns: [
            [
                {
                    linkKey: 'header.mega.kulubumuz.links.imprint',
                    to: '/imprint',
                },
                {
                    linkKey: 'header.mega.kulubumuz.links.history',
                    to: '/history',
                },
                {
                    linkKey: 'header.mega.kulubumuz.links.financial',
                    to: '/financial-statements',
                },
                {
                    linkKey: 'header.mega.kulubumuz.links.management',
                    to: '/management-board',
                },
            ],
            [
                {
                    linkKey: 'header.mega.kulubumuz.links.pastPresidents',
                    to: '/past-presidents',
                },
                {
                    linkKey: 'header.mega.kulubumuz.links.duayen60',
                    to: '/60-year-honorary-members',
                },
                {
                    linkKey: 'header.mega.kulubumuz.links.seniorFive',
                    to: '/senior-five-presidents',
                },
            ],
        ],
    },
    {
        id: 'rotary',
        labelKey: 'header.mega.rotary.label',
        activePathMatchers: [
            '/about-rotary',
            '/what-is-rotary',
            '/rotary-worldwide',
            '/rotary-in-turkey',
        ],
        introTitleKey: 'header.mega.rotary.introTitle',
        introTextKey: 'header.mega.rotary.introText',
        columns: [
            [
                {
                    linkKey: 'header.mega.rotary.links.whatIs',
                    to: '/what-is-rotary',
                },
                {
                    linkKey: 'header.mega.rotary.links.worldwide',
                    to: '/rotary-worldwide',
                },
                {
                    linkKey: 'header.mega.rotary.links.turkey',
                    to: '/rotary-in-turkey',
                },
            ],
        ],
    },
    {
        id: 'hizmetler',
        labelKey: 'header.mega.hizmetler.label',
        activePathMatchers: [
            '/our-services',
            '/projects',
            '/istanbul-rotaract',
            '/interact-clubs',
        ],
        introTitleKey: 'header.mega.hizmetler.introTitle',
        introTextKey: 'header.mega.hizmetler.introText',
        columns: [
            [
                {
                    linkKey: 'header.mega.hizmetler.links.projects',
                    to: '/projects',
                },
            ],
            [
                {
                    linkKey: 'header.mega.hizmetler.links.rotaract',
                    to: '/istanbul-rotaract',
                },
                {
                    linkKey: 'header.mega.hizmetler.links.interact',
                    to: '/interact-clubs',
                },
            ],
        ],
    },
];

/** @type {{ linkKey: string, to: string, end?: boolean }[]} */
export const HEADER_SIMPLE_LINKS = [
    { linkKey: 'header.simple.news', to: '/news' },
    { linkKey: 'header.simple.meetings', to: '/meetings' },
    { linkKey: 'header.simple.contact', to: '/contact' },
];
